import React, { Component, Fragment } from "react";
import { Button, Row, Card, CardBody } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import Breadcrumb from "../../containers/navs/Breadcrumb";

export default class BlankPage extends Component {
  render() {
    return (
      <Fragment>
        <div className="d-flex justify-content-start mt-2">
          <h1>Quick Start with AI</h1>
        </div>
        <div className="d-flex justify-content-start mb-2" style={{ marginTop: '-1rem' }}>
          <p>You're on the fastest path to automation with AI tools </p>
        </div>
        <div className="row">
          <div className="mb-4 col-12">
            <Card style={{ borderRadius: '50px' }}>
              <CardBody>
                <div style={{ padding: "2rem", paddingTop: "1rem" }}>
                  <div className="my-3">
                    <div
                      className="w-60 w-sm-100 active" style={{ cursor: 'pointer' }} onClick={() => window.location.href = "/app/dashboards/analytics"}>
                      <h5 style={{ color: 'var(--theme-color-1)' }} className="list-item-heading mb-1 color-theme-1">Insights that Empower</h5>
                      <p className="mb-2 text-muted text-small">Insights</p>
                      <p className="mb-4 text-small">See how your Chatbot is engaging the guests and gain insights into stats like website visitors, commonly asked questions, and much more.
                      </p></div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div className="w-40 w-sm-100 active" style={{ cursor: 'pointer' }} >
                      <h5 style={{ color: 'var(--theme-color-1)' }} className="list-item-heading mb-1 color-theme-1">Train Chatbot</h5>
                      <p className="mb-1 text-muted text-small">Knowledge Hub</p>
                      <p className="mb-4 text-small">Train Chatbot with information about your property like check in time, activities etc.</p></div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div className="w-40 w-sm-100 active" style={{ cursor: 'pointer' }} onClick={() => window.location.href = "/app/pages/propinfo/forms"}>
                      <h5 style={{ color: 'var(--theme-color-1)' }} className="list-item-heading mb-1 color-theme-1">Automate with Forms</h5>
                      <p className="mb-1 text-muted text-small">Form Builder</p>
                      <p className="mb-4 text-small">Create custom forms and get notifications when guest submits a form.</p></div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div className="w-40 w-sm-100 active" style={{ cursor: 'pointer' }} onClick={() => window.location.href = "/app/pages/integration/channels"}>
                      <h5 style={{ color: 'var(--theme-color-1)' }} className="list-item-heading mb-1 color-theme-1">Add AI Chatbot to your Website</h5>
                      <p className="mb-1 text-muted text-small">Settings | Web Widget | Chatbot</p>
                      <p className="mb-4 text-small">Customize and add Web Widget to your website with an integrate AI Chatbot.</p></div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div className="w-40 w-sm-100 active" style={{ cursor: 'pointer' }} onClick={() => window.location.href = "/app/pages/propinfo/services"}>
                      <h5 style={{ color: 'var(--theme-color-1)' }} className="list-item-heading mb-1 color-theme-1">In Room Digital Compendium</h5>
                      <p className="mb-1 text-muted text-small">Digital Compendium</p>
                      <p className="mb-4 text-small">In room QR code to see information about the property and location.</p></div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div className="w-40 w-sm-100 active" style={{ cursor: 'pointer' }} onClick={() => window.open("https://help.myma.ai/en/", "_target")}>
                      <h5 style={{ color: 'var(--theme-color-1)' }} className="list-item-heading mb-1 color-theme-1">Support</h5>
                      <p className="mb-1 text-muted text-small">Help Center | Chat</p>
                      <p className="mb-4 text-small">Search for articles about common FAQ’s, integrations and more. Ask question to our team on Live Chat.</p></div>
                  </div>
                  <Separator></Separator>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </Fragment>
    )
  }
}
